import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "./locales/en.json";
import translationAr from "./locales/ar.json";
import LanguageDetector from "i18next-browser-languagedetector";

const i18nConfig = {
  resources: {
    en: {
      translation: translationEn,
    },
    ar: {
      translation: translationAr,
    },
  },
  fallbackLng: "en", 
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['path', 'querystring', 'cookie', 'localStorage', 'navigator'], 
    caches: ['cookie', 'localStorage'],
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...i18nConfig,
    supportedLngs: ['en', 'ar'], 
  });
